/**
 *  @class
 *  @function SlideShow
 */
if (!customElements.get('slide-show')) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();
      const slideshow = this;
      let
        parent_section = slideshow.closest('.shopify-section'),
        dots = slideshow.dataset.dots === 'true',
        slideshow_slides = Array.from(slideshow.querySelectorAll('.carousel__slide')),
        slides_columns = slideshow.dataset.columns ? parseInt(slideshow.dataset.columns) : 3,
        autoplay = slideshow.dataset.autoplay == 'false' ? false : parseInt(slideshow.dataset.autoplay, 10),
        align = slideshow.dataset.align == 'center' ? 'center' : 'left',
        fade = slideshow.dataset.fade == 'true' ? true : false,
        pageDots = slideshow.dataset.dots == 'true' ? true : false,
        prev_button = slideshow.querySelector('.flickity-prev'),
        next_button = slideshow.querySelector('.flickity-next'),
        header = document.querySelector('theme-header'),
        custom_dots = slideshow.querySelector('.flickity-custom-dots'),
        custom_navigation = slideshow.querySelector('.flickity-custom-navigation'),
        autoplay_progress = slideshow.querySelector('.slideshow--autoplay-progress'),
        progress_bar = slideshow.parentNode.querySelector('.flickity-progress--bar'),
        animations = [],
        animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined',
        selectedIndex = 0,
        tick = autoplay ? window.setInterval(autoplay, 10) : false,
        args = {
          wrapAround: true,
          cellAlign: align,
          pageDots: pageDots,
          contain: true,
          fade: fade,
          autoPlay: autoplay,
          prevNextButtons: false,
          cellSelector: '.carousel__slide',
          pauseAutoPlayOnHover: false,
          on: {}
        };
      this.paused = false;
      if (custom_dots) {
        args.pageDots = false;
      }
      if (slideshow.classList.contains('image-with-text-slideshow--content')) {
        let main_slideshow = slideshow.parentNode.querySelector('.image-with-text-slideshow--image');
        args.draggable = false;
        args.asNavFor = main_slideshow;
      }
      if (slideshow.classList.contains('image-with-text-slideshow--image')) {
        let image_slideshow_slides = slideshow.querySelectorAll('.image-with-text-slideshow--image-media');

        if (image_slideshow_slides.length) {
          if (image_slideshow_slides[0].classList.contains('desktop-height-auto')) {
            args.adaptiveHeight = true;
          }
        }
      }
      if (slideshow.classList.contains('image-with-text-slideshow--content') ||
        slideshow.classList.contains('customer-reviews--content') ||
        slideshow.classList.contains('customer-reviews--image')) {
        args.adaptiveHeight = true;
      }
      if (slideshow.classList.contains('customer-reviews--carousel')) {
        args.wrapAround = false;
        args.adaptiveHeight = false;
        args.resize = true;
        args.on.ready = function() {
          let flkty = this;
          flkty.resize();
          document.fonts.ready.then(function() {
            flkty.resize();
          });
        };
      }
      if (slideshow.classList.contains('collection-grid__carousel')) {
        args.wrapAround = false;
      }
      // video tabs slideshow
      if (slideshow.classList.contains('video-slideshow')) {
        if(slideshow.classList.contains('mobile-no-slideshow') && window.innerWidth < 800){return}
        
        if(window.innerWidth > 768) {
          if(window.innerWidth + slideshow_slides[0].clientWidth < slideshow_slides.length * slideshow_slides[0].clientWidth) {
            args.wrapAround = true;
          }else {
            args.wrapAround = false
          }
          if(slideshow_slides.length>2) {
            args.initialIndex = 1
            args.contain = false
          }
        }else {
          args.wrapAround = false
        }
        args.draggable = true
        args.cellAlign = window.innerWidth > 768 ? 'center' : 'left'
        args.groupCells = 1
        // if(window.innerWidth > 768)args.groupCells = 3
        // 标记是否已经插入过弹窗 DOM
        this.modalInserted = false;
        this.modal =null;
        this.videoPlayer = null
        let _this = this
        let vt2Dots = slideshow.parentElement.nextElementSibling?.querySelectorAll('.vt2-dot')
        
        args.on = {
          staticClick: function(event, pointer, cellElement, cellIndex) {
            if (!cellElement) return;
            let vid = cellElement.dataset.vid
            if(!vid) return
                // 创建模态框的外部容器
                const modal = document.createElement('div');
                modal.classList.add('video-modal-new');
                 
                // 创建模态框内部内容
                const modalContent = document.createElement('div');
                modalContent.classList.add('modal-content-new');
                
                // 创建关闭按钮
                const closeBtn = document.createElement('span');
                closeBtn.classList.add('close-btn-new');
                closeBtn.innerHTML = `<svg class="mk-close-btn mk-cursor-pointer mk-absolute mk-right-0 mk-top-0" xmlns="http://www.w3.org/2000/svg" width="16px" height="16.00px" viewBox="0 0 1024 1024" version="1.1">
                        <path fill="#ffffff" d="M780.309 839.716l-597.298-597.298 60.339-60.339 597.298 597.298-60.339 60.339zM243.412 840.144l-60.339-60.339 597.328-597.328 60.339 60.339-597.328 597.328z"></path>
                    </svg>`; // Close button content
                
                // 创建 YouTube iframe
                const iframe = document.createElement('iframe');
                iframe.setAttribute('data-src', `https://www.youtube.com/embed/${vid}?loop=1&autoplay=1&mute=1&playlist=${vid}&iv_load_policy=3&disablekb=1&controls=1&playsinline=1&showinfo=0&ref=0`);
                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allow', 'autoplay; encrypted-media');
                iframe.setAttribute('allowfullscreen', '');
                iframe.setAttribute('tabindex', '-1');
                
                // 插入内容到模态框
                modalContent.appendChild(closeBtn);
                modalContent.appendChild(iframe);
                modal.appendChild(modalContent);
                
                // 将模态框添加到 body 中
                document.body.appendChild(modal);
                
                // 加载 YouTube 视频
                iframe.src = iframe.getAttribute('data-src');

                // 显示模态框
                modal.style.display = 'flex';

                // 关闭模态框的功能
                closeBtn.addEventListener('click', function() {
                    // 停止视频并移除模态框
                    iframe.src = ''; // 停止视频
                    document.body.removeChild(modal); // 移除模态框
                });
          },
          ready: function() {
            let _this = this
            if(vt2Dots&&vt2Dots.length > 0) {
              vt2Dots.forEach((dot,i) => {
                dot.addEventListener('click',()=>{
                  let currentIndex = this.selectedIndex - 1
                  if(i == currentIndex) return
                  this.select(i+1)
                  vt2Dots.forEach(v => v.classList.remove('active'))
                  dot.classList.add('active')
                })
              })
            }
            function handleResize() {
              if(window.innerWidth > slideshow_slides.length * slideshow_slides[0].clientWidth) {
                args.wrapAround = false
                args.contain = true
                _this.destroy()
                window.removeEventListener('resize', optimizedResize);
                // console.log(_this,222);
                // _this.flickity()
                // console.log(flkty,3333);
                setTimeout(() => {
                  _this = new Flickity(slideshow, args)
                }, 0);
              }else {
                args.wrapAround = true
                args.contain = false
                _this.destroy()
                window.removeEventListener('resize', optimizedResize);
                // console.log(_this,222);
                // _this.flickity()
                // console.log(flkty,3333);
                setTimeout(() => {
                  _this =new Flickity(slideshow, args)
                }, 0);
              }
            }
            function debounce(func, delay = 300) {
              let timer;
              return function() {
                clearTimeout(timer);
                timer = setTimeout(() => func.apply(this, arguments), delay);
              };
            }
            
            const optimizedResize = debounce(handleResize);
            // if(window.innerWidth > 768)window.addEventListener('resize', optimizedResize);
          },
          change: function(index) {
            if(vt2Dots&&vt2Dots.length > 0) {
              vt2Dots.forEach(v => v.classList.remove('active'))
              let currentIndex = this.selectedIndex - 1 >= 0 ? this.selectedIndex - 1 : vt2Dots.length - 1
              vt2Dots[currentIndex].classList.add('active')
            }
          }
        }
        var maxHeight = 0;
        slideshow_slides.forEach(item => {
          var height = item.offsetHeight;
          if (height > maxHeight) {
            maxHeight = height;
          }
        })
        // 将所有幻灯片的高度设置为最大高度
        slideshow_slides.forEach(function(slide){
          slide.style.height = maxHeight + 'px';
        });
      }
      // features-slideshow
      if (slideshow.classList.contains('main-features')) {
        prev_button = slideshow.parentNode.querySelector('.slide-prev')
        next_button = slideshow.parentNode.querySelector('.slide-next')
        // args.imagesLoaded= true // 等待图片加载完成
        var maxHeight = 0;
        slideshow_slides.forEach(item => {
          var height = item.offsetHeight;
          if (height > maxHeight) {
            maxHeight = height;
          }
        })
        // 将所有幻灯片的高度设置为最大高度
        slideshow_slides.forEach(function(slide){
          slide.style.height = maxHeight + 'px';
        });
      }
      if (slideshow.classList.contains('child-features')) {
        args.wrapAround = false
        args.draggable = false
        args.cellAlign = 'center'
        let main_slideshow = slideshow.parentNode.parentNode.querySelector('.main-features')
        args.asNavFor = main_slideshow
      }
      // mobile menu slideshow
      if(slideshow.classList.contains('mobile-menu-slideshow')) {
        args.wrapAround = false
        // args.contain =
        args.freeScroll = true
        
        args.on = {
          ready: function() {
            let flkty = this
            flkty.resize();
            document.fonts.ready.then(function() {
              flkty.resize();
            });
          }
        }
        var maxHeight = 0;
        slideshow_slides.forEach(item => {
          var height = item.offsetHeight;
          if (height > maxHeight) {
            maxHeight = height;
          }
        })
        // 将所有幻灯片的高度设置为最大高度
        slideshow_slides.forEach(function(slide){
          slide.style.height = maxHeight + 'px';
        });
      }
      // Main Slideshow
      if (slideshow.classList.contains('main-slideshow')) {

        if (animations_enabled) {
          slideshow.prepareAnimations(slideshow, animations);
        }

        args.on = {
          staticClick: function() {
            this.unpausePlayer();
          },
          ready: function() {
            let flkty = this;

            // Transparent Header padding.
            if (header.classList.contains('transparent--true')) {
              let sections = Array.from(document.querySelector('#main-content').querySelectorAll(':scope > .shopify-section')),
                i = sections.indexOf(parent_section);

              if (i == 0 && slideshow.classList.contains('section-spacing--disable-top')) {
                slideshow.classList.add('slideshow--top');
              }
            }
            // Animations.
            if (animations_enabled) {
              slideshow.animateSlides(0, slideshow, animations);
            }

            // AutoPlay Progress
            if (autoplay && autoplay_progress && animations_enabled) {
              slideshow.setupAutoplayProgress(slideshow);
            }

            // Fonts resize
            document.fonts.ready.then(function() {
              flkty.resize();
            });

            // Video Support.
            let video_container = flkty.cells[0].element.querySelector('.slideshow__slide-video-bg');
            if (video_container) {

              if (video_container.querySelector('iframe')) {
                video_container.querySelector('iframe').onload = function() {
                  slideshow.videoPlay(video_container);
                };
              } else if (video_container.querySelector('video')) {
                video_container.querySelector('video').onloadstart = function() {
                  slideshow.videoPlay(video_container);
                };
              }
            }
          },
          change: function(index) {
            let flkty = this,
              previousIndex = fizzyUIUtils.modulo(flkty.selectedIndex - 1, flkty.slides.length);

            // Animations.
            if (animations_enabled) {
              slideshow.animateReverse(previousIndex, slideshow, animations);
              slideshow.animateSlides(index, slideshow, animations);
            }

            // Color changes.
            let color_text = getComputedStyle(this.selectedElement).getPropertyValue('--color-text');
            if (autoplay_progress && animations_enabled) {
              autoplay_progress.style.setProperty('--color-body', color_text);
            }
            let dots = slideshow.querySelector('.flickity-page-dots');
            if (dots) {
              dots.style.setProperty('--color-body', color_text);
            }

            // Custom Dots.
            if (custom_navigation) {
              custom_navigation.querySelector('.flickity-custom-navigation--current').innerHTML = this.selectedIndex + 1;
            }

            // AutoPlay Progress
            if (autoplay) {

              if (flkty.player.state !== 'paused') {
                flkty.stopPlayer();
                flkty.playPlayer();
              }
            }
            if (autoplay && autoplay_progress && animations_enabled) {
              slideshow.autoPlayProgressTL.progress(0);

              if (flkty.player.state !== 'paused') {
                slideshow.autoPlayProgressTL.play();
              }
            }

            // Video Support.
            // previous slide
            let video_container_prev = flkty.cells[previousIndex].element.querySelector('.slideshow__slide-video-bg');
            if (video_container_prev) {
              slideshow.videoPause(video_container_prev);
            }
            // current slide
            let video_container = flkty.cells[index].element.querySelector('.slideshow__slide-video-bg');
            if (video_container) {
              if (video_container.querySelector('iframe')) {
                if (video_container.querySelector('iframe').classList.contains('lazyload')) {
                  video_container.querySelector('iframe').addEventListener('lazybeforeunveil', slideshow.videoPlay(video_container));
                  lazySizes.loader.checkElems();
                } else {
                  slideshow.videoPlay(video_container);
                }
              } else if (video_container.querySelector('video')) {
                slideshow.videoPlay(video_container);
              }
            }

          }
        };
        if (slideshow.classList.contains('desktop-height-image') || slideshow.classList.contains('mobile-height-image')) {
          args.adaptiveHeight = true;
        }
      }

      // Media with tabs
      if (slideshow.classList.contains('media-with-tabs--media')) {
        args.draggable = false;
        args.on = {
          staticClick: function() {
            this.unpausePlayer();
          },
          ready: function() {
            let flkty = this;

            // Video Support.
            let video_container = flkty.cells[0].element.querySelector('.media-with-tabs--media--video');
            if (video_container) {
              video_container.querySelector('video').onloadstart = function() {
                slideshow.videoPlay(video_container);
              };
            }
          },
          change: function(index) {
            let flkty = this,
              previousIndex = fizzyUIUtils.modulo(flkty.selectedIndex - 1, flkty.slides.length);

            // Video Support.
            // previous slide
            let video_container_prev = flkty.cells[previousIndex].element.querySelector('.media-with-tabs--media--video');
            if (video_container_prev) {
              slideshow.videoPause(video_container_prev);
            }
            // current slide
            let video_container = flkty.cells[index].element.querySelector('.media-with-tabs--media--video');
            if (video_container) {
              slideshow.videoPlay(video_container);
            }
          }
        };
      }

      // Announcement bar color change
      if (slideshow.classList.contains('announcement-bar--use-colors-true')) {
        args.on.change = function(index) {
          const container = slideshow.closest('.announcement-bar');
          let color_text = this.selectedElement.dataset.color,
            color_bg = this.selectedElement.dataset.bg;

          container.style.setProperty('--color-announcement-bar-bg', color_bg);
          container.style.setProperty('--color-announcement-bar-text', color_text);
        };
      }

      // Product Carousels
      if (slideshow.classList.contains('products')) {
        args.wrapAround = false;
        args.on.ready = function() {
          var flickity = this;
          if (next_button) {
            window.addEventListener('resize.center_arrows', function() {
              slideshow.centerArrows(flickity, slideshow, prev_button, next_button);
            });
          }
          window.dispatchEvent(new Event('resize.center_arrows'));
        };
      }
      if (progress_bar) {
        args.wrapAround = false;
        args.on.scroll = function(progress) {
          progress = Math.max(0, Math.min(1, progress));
          progress_bar.style.width = progress * 100 + '%';
        };
      }

      // Testimonials
      if (custom_dots) {
        args.on = {
          ready: function() {
            let flkty = this;

            // Custom Dots.
            let dots = custom_dots.querySelectorAll('li');
            dots.forEach((dot, i) => {
              dot.addEventListener('click', (e) => {
                flkty.select(i);
              });
            });
            dots[this.selectedIndex].classList.add('is-selected');
          },
          change: function(index) {

            // Custom Dots.
            let dots = custom_dots.querySelectorAll('li');
            dots.forEach((dot, i) => {
              dot.classList.remove('is-selected');
            });
            dots[this.selectedIndex].classList.add('is-selected');
          }
        };
      }

      // Customer reviews
      if (slideshow.classList.contains('customer-reviews--carousel')) {
        args.on.ready = function() {
          var flickity = this;
          if (next_button) {
            window.addEventListener('resize.center_arrows', function() {
              slideshow.centerArrows(flickity, slideshow, prev_button, next_button);
            });
          }
          window.dispatchEvent(new Event('resize.center_arrows'));
        };
      }
      // Initiate
      const flkty = new Flickity(slideshow, args);

      selectedIndex = flkty.selectedIndex;

      slideshow.dataset.initiated = true;
      if(slideshow.classList.contains('mobile-menu-slideshow')) {
        if(flkty) {
        window.addEventListener('resize', function() {
          flkty.resize();
        });          
        }
      }
      // if(slideshow.classList.contains('video-slideshow')) {
      //   let nextBtn = slideshow.parentNode.querySelector('.slide-next')
      //   let prevBtn = slideshow.parentNode.querySelector('.slide-prev')
      //   if(flkty.cells.length < (slides_columns + 1)) {
      //     nextBtn.style.display = 'none'
      //     prevBtn.style.display = 'none'
      //   }
      //   if(nextBtn) {
      //     nextBtn.addEventListener('click', () => {
      //       flkty.next()
      //     })
      //   }
      //   if(prevBtn) {
      //     prevBtn.addEventListener('click', () => {
      //       flkty.previous()
      //     })
      //   }
      // }
      // Arrows
      if (prev_button) {
        prev_button.addEventListener('click', (event) => {
          flkty.previous();
        });
        prev_button.addEventListener('keyup', (event) => {
          flkty.previous();
        });
        next_button.addEventListener('click', (event) => {
          flkty.next();
        });
        next_button.addEventListener('keyup', (event) => {
          flkty.next();
        });
      }

      // Theme editor
      if (Shopify.designMode) {
        slideshow.addEventListener('shopify:block:select', (event) => {
          let index = slideshow_slides.indexOf(event.target);
          flkty.select(index);
        });
      }

    }
    setupAutoplayProgress(slideshow) {
      slideshow.autoPlayProgressTL = gsap.timeline({
        inherit: false
      });
      slideshow.autoPlayProgressTL
        .fromTo(slideshow.querySelector('.thb-slideshow-progress--svg circle'), {
          drawSVG: 0
        }, {
          duration: parseInt(slideshow.dataset.autoplay, 10) / 1000,
          ease: 'none',
          drawSVG: true
        });
      slideshow.addEventListener('mouseenter', function() {
        slideshow.autoPlayProgressTL.pause().progress(0);
      });
      slideshow.addEventListener('mouseleave', function() {
        slideshow.autoPlayProgressTL.play();
      });
    }

    videoPause(video_container) {
      setTimeout(() => {
        video_container.querySelector('video').pause();
      }, 10);
    }
    videoPlay(video_container) {
      setTimeout(() => {
        video_container.querySelector('video').play();
      }, 10);
    }
    prepareAnimations(slideshow, animations) {
      if (!slideshow.dataset.animationsReady) {
        let splittext = new SplitText(slideshow.querySelectorAll('.slideshow__slide-heading, p:not(.subheading)'), {
          type: 'lines',
          linesClass: 'line-child'
        });
        let mask = new SplitText(slideshow.querySelectorAll('.slideshow__slide-heading, p:not(.subheading)'), {
          type: 'lines',
          linesClass: 'line-parent'
        });

        slideshow.querySelectorAll('.slideshow__slide').forEach((item, i) => {
          let tl = gsap.timeline({
              paused: true
            }),
            button_offset = 0;


          animations[i] = tl;

          if (slideshow.dataset.transition == 'zoom') {
            tl
              .to(item.querySelectorAll('.slideshow__slide-bg, .slideshow__slide-video-bg'), {
                duration: 1.5,
                scale: 1
              }, "start");
          }

          if (item.querySelector('.inline-badge')) {
            tl
              .fromTo(item.querySelector('.inline-badge'), {
                opacity: 0
              }, {
                duration: 0.5,
                opacity: 1
              }, 0);

            button_offset += 0.2;
          }
          if (item.querySelector('.subheading')) {
            tl
              .fromTo(item.querySelector('.subheading'), {
                opacity: 0
              }, {
                duration: 0.5,
                opacity: 1
              }, 0);

            button_offset += 0.5;
          }
          if (item.querySelector('h1')) {
            let h1_duration = 1 + ((item.querySelectorAll('.slideshow__slide-heading .line-child').length - 1) * 0.1);
            tl

              .set(item.querySelectorAll('.slideshow__slide-heading'), {
                opacity: 1
              }, 0)
              .from(item.querySelectorAll('.slideshow__slide-heading .line-child'), {
                duration: h1_duration,
                yPercent: 120,
                stagger: 0.1,
                rotation: '3deg'
              }, 0);
            button_offset += h1_duration;
          }
          if (item.querySelector('p.split-text')) {

            let p_duration = 1 + ((item.querySelectorAll('p.split-text .line-child').length - 1) * 0.05);
            tl
              .set(item.querySelectorAll('p.split-text'), {
                opacity: 1
              }, 0)
              .from(item.querySelectorAll('p:not(.subheading) .line-child'), {
                duration: p_duration,
                yPercent: '120',
                stagger: 0.1,
                rotation: '3deg'
              }, 0);
            button_offset += p_duration;
          }
          if (item.querySelectorAll('.button, .text-button')) {
            tl
              .fromTo(item.querySelectorAll('.button, .text-button'), {
                y: '100%'
              }, {
                duration: 0.5,
                y: '0%',
                stagger: 0.1,
              }, button_offset * 0.2);
          }
          item.dataset.timeline = tl;
        });

        slideshow.dataset.animationsReady = true;
      }
    }
    animateSlides(i, slideshow, animations) {
      let flkty = Flickity.data(slideshow),
        active_slide = flkty.selectedElement;
      document.fonts.ready.then(function() {
        animations[i].restart();
      });
    }
    animateReverse(i, slideshow, animations) {
      animations[i].reverse();
    }
    centerArrows(flickity, slideshow, prev_button, next_button) {
      let first_cell = flickity.cells[0],
        max_height = 0,
        image_height = 0;
      if (first_cell.element.querySelector('.product-featured-image')) {
        image_height = first_cell.element.querySelector('.product-featured-image').clientHeight;
      } else if (first_cell.element.querySelector('.gallery--item')) {
        image_height = flickity.cells[1].element.querySelector('.product-featured-image').clientHeight;
      }
      if (slideshow.classList.contains('customer-reviews--carousel')) {
        if (first_cell.element.querySelector('.customer-reviews--product')) {
          image_height = flickity.cells[1].element.querySelector('.customer-reviews--product').clientHeight;
        }
      }
      if (image_height > 0) {
        flickity.cells.forEach((item, i) => {
          if (item.size.height > max_height) {
            max_height = item.size.height;
          }
        });

        if (max_height > image_height) {
          let difference = (max_height - image_height) / -2;

          prev_button.style.transform = 'translateY(' + difference + 'px)';
          next_button.style.transform = 'translateY(' + difference + 'px)';
        }
      }

    }
  }
  customElements.define('slide-show', SlideShow);
}